/**
 * Created by renjie.huang on 2017/11/8.
 */

var request = require('../common/request');
var Promise = require('promise');
var action = require('../common/action');
var _ = require('_');

var service = {
    getUserInfo : ()=>{
        var promise = new Promise(function(resolve,reject){
            request(action.login.getUserInfo).success(function(data){
                resolve(data);
            }).fail(function(data){
                reject(data)
            })
        })

        return promise;
    },
    // 获取用户的认证信息
    getUserAuthInfo: () => {
        return new Promise((resolve, reject) => {
            request(action.login.GetUserAuthInfo)
            .success((res) => resolve(res))
            .fail((err) => reject(err))
        })
    },


    modifyUserInfo : (data)=>{
        var promise = new Promise(function(resolve,reject){
            request(action.login.modifyUserInfo,data).success(function(data){
                resolve(data);
            }).fail(function(data){
                reject(data);
            })
        })

        return promise;
    },
    //用户认证状态 false 未认证 true 已认证
    getAuthState : (authState) =>{
        console.log(authState);
        return authState !== "NOT_CERTIFIED" && authState !== "TO_BE_CERTIFIED";
    },
    //获取子账号密码策略
    getPasswordPolicyForActivateUser : (data)=>{
        var promise = new Promise(function(resolve,reject){
            request(action.login.GetPasswordPolicyForActivateUser,data).success(function(data){
                resolve(data);
            }).fail(function(data){
                reject(data);
            })
        })

        return promise;
    },
}


module.exports = {
    getUserInfo : service.getUserInfo,
    modifyUserInfo : service.modifyUserInfo,
    getAuthState: service.getAuthState,
    getUserAuthInfo: service.getUserAuthInfo,
    getPasswordPolicyForActivateUser: service.getPasswordPolicyForActivateUser
}


// WEBPACK FOOTER //
// ./src/service/userService.js